var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app" } }, [
    _c("div", { staticClass: "topbar has-text-white" }, [
      _c("div", { staticClass: "columns is-gapless is-mobile" }, [
        _c("div", { staticClass: "column is-narrow" }, [
          _c(
            "div",
            {
              staticClass: "burger-menu is-pulled-left is-hidden-tablet",
              on: { click: _vm.openMenu }
            },
            [
              _c("b-icon", {
                staticClass: "rp-menu-bar",
                attrs: { pack: "fa", icon: "bars", size: "is-medium" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "system-name" },
            [
              _c("router-link", { attrs: { to: { name: "Home" } } }, [
                _c(
                  "span",
                  { staticClass: "is-size-4 is-hidden-mobile has-text-white" },
                  [
                    _vm._v(
                      "\n              " + _vm._s("R-Shop") + "\n            "
                    )
                  ]
                )
              ])
            ],
            1
          )
        ]),
        _vm._v(" "),
        _vm.getIsRMP === "false"
          ? _c(
              "div",
              { staticClass: "column has-text-right" },
              [
                _c("span", { staticClass: "test rshop-version-container" }, [
                  _vm._v("v." + _vm._s(_vm.version))
                ]),
                _vm._v(" "),
                _c(
                  "b-dropdown",
                  {
                    staticClass: "language-dropdown has-text-left",
                    attrs: { position: "is-bottom-left" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "translation",
                        attrs: { slot: "trigger" },
                        slot: "trigger"
                      },
                      [
                        _vm.$i18n.locale() === "en"
                          ? _c(
                              "div",
                              [
                                _c("flag", { attrs: { iso: "US" } }),
                                _vm._v(" EN")
                              ],
                              1
                            )
                          : _vm.$i18n.locale() === "th"
                          ? _c(
                              "div",
                              [
                                _c("flag", { attrs: { iso: "TH" } }),
                                _vm._v(" TH")
                              ],
                              1
                            )
                          : _vm.$i18n.locale() === "vi"
                          ? _c(
                              "div",
                              [
                                _c("flag", { attrs: { iso: "VN" } }),
                                _vm._v(" VI")
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.getLanguageSwitcherList, function(lang, index) {
                      return _c(
                        "b-dropdown-item",
                        {
                          key: index,
                          on: {
                            click: function($event) {
                              return _vm.setLanguage(lang)
                            }
                          }
                        },
                        [
                          lang === "th"
                            ? _c(
                                "span",
                                [
                                  _c("flag", { attrs: { iso: "TH" } }),
                                  _vm._v(" Thai")
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          lang === "en"
                            ? _c(
                                "span",
                                [
                                  _c("flag", { attrs: { iso: "US" } }),
                                  _vm._v(" English")
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          lang === "vi"
                            ? _c(
                                "span",
                                [
                                  _c("flag", { attrs: { iso: "VN" } }),
                                  _vm._v(" Vietnam")
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("rshop-manual-link", {
                  attrs: { lang: _vm.$i18n.locale(), rmp: "no" }
                }),
                _vm._v(" "),
                _vm.account.webName != ""
                  ? [
                      _vm._v("\n           | \n          "),
                      _c(
                        "span",
                        { on: { click: _vm.logoutConfirm } },
                        [
                          _c("b-icon", {
                            staticClass: "rpshop-logout-button",
                            attrs: {
                              title: _vm.$t("_logout"),
                              pack: "fa",
                              icon: "power-off"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  : _vm._e()
              ],
              2
            )
          : _c(
              "div",
              { staticClass: "column has-text-right is-rmp" },
              [
                _c("span", { staticClass: "test rshop-version-container" }, [
                  _vm._v("v." + _vm._s(_vm.version))
                ]),
                _vm._v(" "),
                _c("rshop-manual-link", {
                  attrs: { lang: _vm.$i18n.locale(), rmp: "yes" }
                }),
                _vm._v(" "),
                _vm.account.webName != ""
                  ? [
                      _c("div", {
                        staticClass: "rmp-widget",
                        attrs: { id: "rmp_widget", "data-source-app-id": "4" }
                      })
                    ]
                  : _vm._e()
              ],
              2
            )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "section-main columns is-gapless" }, [
      _c(
        "div",
        { staticClass: "shop-sidebar column is-narrow is-hidden-mobile" },
        [
          _c("sidebar", {
            model: {
              value: _vm.showSidebarSubMenus,
              callback: function($$v) {
                _vm.showSidebarSubMenus = $$v
              },
              expression: "showSidebarSubMenus"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "shop-content column" }, [_c("router-view")], 1)
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal menu-modal",
        class: { "is-active": _vm.menuModal }
      },
      [
        _c("div", { staticClass: "modal-background" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "modal-content" },
          [
            _c("sidebar", {
              attrs: { "show-close-button": "true" },
              on: {
                toggleSubMenu: _vm.toggleSidebarSubMenu,
                closemenu: _vm.closeMenu
              },
              model: {
                value: _vm.showSidebarSubMenus,
                callback: function($$v) {
                  _vm.showSidebarSubMenus = $$v
                },
                expression: "showSidebarSubMenus"
              }
            }),
            _vm._v(" "),
            _vm.showSidebarSubMenus
              ? _c("sidebar-settings", { on: { closemenu: _vm.closeMenu } })
              : _vm._e()
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 386
// module chunks = 12